import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getCurrentProject } from '../../modules/project';
import IntegrationOptions from './IntegrationOptions';
import PlatformIntegrationSection from './PlatformIntegrationSection';
import Loader from '../elements/Loader';

const Integrations = ({ isAdmin }) => {
  const [currentProject, setCurrentProject] = useState(null);
  const [isConnected, setIsConnected] = useState(null);
  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);

  const fetchCurrentProject = async () => {
    setLoading(true);
    try {
      const currentProject = await getCurrentProject(projectId);
      setCurrentProject(currentProject);
      if (currentProject?.integrated_platform === 'jira') {
        setIsConnected(true);
      } else {
        setIsConnected(false);
      }
    } catch (error) {
      console.log(error);
      setIsConnected(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCurrentProject();
  }, []);

  return (
    <Container fluid className="px-0">
      {loading || isConnected === null || currentProject === null ? (
        <Loader />
      ) : isConnected ? (
        <PlatformIntegrationSection
          isAdmin={isAdmin}
          currentProject={currentProject}
        />
      ) : (
        <Box textAlign="center" sx={{ mt: 4 }}>
          <IntegrationOptions
            setIsConnected={setIsConnected}
            isAdmin={isAdmin}
          />
        </Box>
      )}
    </Container>
  );
};

export default Integrations;
